<script setup lang="ts">
const { data: modalState, setData: setModalState } = useModalState();

const target = ref(null);

onClickOutside(target, () => {
  setModalState(null);
});
</script>

<template>
  <div v-if="modalState?.type" class="modal">
    <!-- Close button for mobile -->
    <button
      aria-label="Close dialog"
      class="absolute top-0 right-0 w-12 h-12 flex items-center justify-center lg:hidden z-[101] text-gray-900"
      @click="setModalState(null)"
    >
      <i aria-hidden="true" class="fa fa-times text-[24px]"></i>
    </button>

    <div ref="target" class="mx-4 mt-16 mb-4 lg:mx-10 lg:my-0">
      <!-- <DashboardMyPlansAssignPayment
        v-if="modalState?.type === 'new_payment_method'"
      /> -->
      <DashboardMyPlansServiceAddress
        v-if="modalState?.type === 'view/update_service_address'"
      />
      <!-- <DashboardMyPlansChangePlan v-if="modalState?.type === 'change_plan'" /> -->
      <!-- Two-step verification is now a standalone page at /account/verification -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  @apply fixed w-screen h-screen bg-black/50 flex items-center justify-center
  z-[100];
}
</style>
